<div class="filter-group" data-group-visibility-id="showRemainingGearFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showRemainingGearFilters" (click)="filter.groupVisibility.showRemainingGearFilters = !filter.groupVisibility.showRemainingGearFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Hide Remaining Gear" [activeRules]="activeRules.remainingGearFilters">
          <strong>Identified</strong> Gear is governed by the Identified Items rule group further up.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showRemainingGearFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showRemainingGearFilters">

      <div class="filter filter-property full-span" [class.disabled-filter-property-container]="filter.showLevelingGear" [class.disabled]="!filter.hideAllOtherGear || filter.showLevelingGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideAllOtherGear && !filter.showLevelingGear" [disabled]="filter.showLevelingGear"
          (click)="toggleHideAllOtherGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide All Remaining Non-Unique Gear" ruleId="gear-hide-remaining">
          </span>
        </span>

        @if (filter.showLevelingGear) {
          <div class="disabled-filter-property" (click)="navigateToLevelingGear()">
            Managed by <strong>Leveling Gear</strong> settings.
          </div>
        }
      </div>

    </div>
    <div class="clear"></div>
  }
</div>

<div class="filter-group" data-group-visibility-id="showRemainingJewelleryFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showRemainingJewelleryFilters" (click)="filter.groupVisibility.showRemainingJewelleryFilters = !filter.groupVisibility.showRemainingJewelleryFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Hide Remaining Jewellery" [activeRules]="activeRules.remainingJewelleryFilters">
          <strong>Identified</strong> Jewellery and Jewels are governed by the Identified Items rule group further up.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showRemainingJewelleryFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showRemainingJewelleryFilters">

      <div class="filter full-span" [class.disabled]="!filter.hideAmulets">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideAmulets" (click)="toggleHideAmulets()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide Remaining Amulets by Rarity" ruleId="jewellery-hidden-amulets-normal"></span>
          <span class="sep"></span>
          <app-select-rarity [lessThanOrEqualTo]="true" [disabled]="!filter.hideAmulets" [(ngModel)]="filter.hideAmuletsOfRarity" (selectedValueChange)="updateFilter();"></app-select-rarity>
        </span>
      </div>

      <div class="filter full-span" [class.disabled]="!filter.hideRings">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideRings" (click)="toggleHideRings()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide Remaining Rings by Rarity" ruleId="jewellery-hidden-rings-normal"></span>
          <span class="sep"></span>
          <app-select-rarity [lessThanOrEqualTo]="true" [disabled]="!filter.hideRings" [(ngModel)]="filter.hideRingsOfRarity" (selectedValueChange)="updateFilter();"></app-select-rarity>

        </span>
      </div>

      <div class="filter full-span" [class.disabled]="!filter.hideBelts">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideBelts" (click)="toggleHideBelts()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide Remaining Belts by Rarity" ruleId="jewellery-hidden-belts-normal"></span>
          <span class="sep"></span>
          <app-select-rarity [lessThanOrEqualTo]="true" [disabled]="!filter.hideBelts" [(ngModel)]="filter.hideBeltsOfRarity" (selectedValueChange)="updateFilter();"></app-select-rarity>
        </span>
      </div>

      <div class="filter full-span" [class.disabled]="!filter.hideJewels">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideJewels" (click)="toggleHideJewels()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide Remaining Jewels by Rarity" ruleId="jewels-hidden-normal"></span>
          <span class="sep"></span>
          <app-select-rarity [lessThanOrEqualTo]="true" [includeNormal]="poe1" [disabled]="!filter.hideJewels" [(ngModel)]="filter.hideJewelsOfRarity" (selectedValueChange)="updateFilter();"></app-select-rarity>
        </span>
      </div>

      @if (poe1) {
        <div class="filter full-span" [class.disabled]="!filter.hideTalismans">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.hideTalismans" (click)="toggleHideTalismans()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Hide Remaining Talismans" ruleId="jewellery-hidden-talismans"></span>
          </span>
        </div>
      }
    </div>

    <div class="clear"></div>
  }
</div>

<div class="filter-group" data-group-visibility-id="showRemainingFlaskFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showRemainingFlaskFilters" (click)="filter.groupVisibility.showRemainingFlaskFilters = !filter.groupVisibility.showRemainingFlaskFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Hide Remaining Flasks {{ poe2 ? 'and Charms' : poe1 ? 'and Tinctures' : '' }}" [activeRules]="activeRules.remainingFlaskCharmFilters">
        </span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showRemainingFlaskFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showRemainingFlaskFilters">

      <div class="filter filter-property full-span" [class.disabled-filter-property-container]="filter.showLevelingFlasks" [class.disabled]="filter.showLevelingFlasks">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideLifeFlasks" (click)="toggleHideLifeFlasks()" [disabled]="filter.showLevelingFlasks"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Hide remaining Life Flasks' : 'Hide remaining non-Unique Life Flasks' }}" ruleId="flasks-hidden-life-normal"></span>
        </span>

        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideManaFlasks" (click)="toggleHideManaFlasks()" [disabled]="filter.showLevelingFlasks"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Hide remaining Mana Flasks' : 'Hide remaining non-Unique Mana Flasks' }}" ruleId="flasks-hidden-mana-normal"></span>
        </span>

        @if (filter.showLevelingFlasks) {
          <div class="disabled-filter-property" (click)="navigateToLevelingFlasks()">
            Managed by <strong>Leveling Flasks</strong> settings.
          </div>
        }
      </div>

      @if (poe2) {
        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.hideCharms" (click)="toggleHideCharms()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="{{ isMobile() ? 'Hide remaining Charms' : 'Hide remaining non-Unique Charms' }}" ruleId="charms-hidden-normal"></span>
          </span>
        </div>
      }

      @if (poe1) {
        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.hideHybridFlasks" (click)="toggleHideHybridFlasks()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="{{ isMobile() ? 'Hide rem. Hybrid Flasks' : 'Hide remaining non-Unique Hybrid Flasks' }}" ruleId="flasks-hidden-hybrid-normal"></span>
          </span>
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.hideUtilityFlasks" (click)="toggleHideUtilityFlasks()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="{{ isMobile() ? 'Hide rem. Utility Flasks' : 'Hide remaining non-Unique Utility Flasks' }}" ruleId="flasks-hidden-utility-normal"></span>
          </span>
        </div>

        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.hideTinctures" (click)="toggleHideTinctures()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="{{ isMobile() ? 'Hide remaining Tinctures' : 'Hide remaining non-Unique Tinctures' }}" ruleId="flasks-hidden-tinctures-normal"></span>
          </span>
        </div>
      }

    </div>
    <div class="clear"></div>
  }
</div>
